module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/22e1fb45c852ab96fc6eb36c510ab498.gif";